// import React, { useState } from 'react';
// import {
//   Box,
//   Button,
//   FormControl,
//   FormLabel,
//   Input,
//   Heading,
//   VStack,
//   useToast,
//     InputGroup,
//   InputRightElement,
//   IconButton,
//   FormErrorMessage,
// } from "@chakra-ui/react";
// import { Eye, EyeOff } from "lucide-react";

// export default function CreatePassword() {
//      const toast = useToast();
//       const [hover, setHover] = useState(false);

//       const [email, setEmail] = useState("");

//       const [password, setPassword] = useState("");
//       const [confirmPassword, setConfirmPassword] = useState("");

//       const [showPassword, setShowPassword] = useState(false);
//       const [showConfirmPassword, setShowConfirmPassword] = useState(false);

//       const [errors, setErrors] = useState({});


//       const handleSubmit = (e) => {
//         e.preventDefault();

//         const newErrors = {};

//         if(!email) {
//             newErrors.email = "Email is required";
//         }

//         if(!password) {
//             newErrors.password = "Password is required";
//         }

//         if (!confirmPassword) {
//             newErrors.confirmPassword = "Confirm Password is required";
//         }

//         // if (password !== confirmPassword) {
//         //     toast({
//         //         title: "Passwords do not match",
//         //         description: "Please make sure both passwords are the same.",
//         //         status: "error",
//         //         duration: 4000,
//         //         isClosable: true,
//         //         position: "top",
//         //     });
//         //     return;
//         // }

//         if (password && confirmPassword && password !== confirmPassword) {
//             newErrors.confirmPassword = "Passwords do not match";
//         }
//         setErrors(newErrors);

//         if (Object.keys(newErrors).length > 0) {
//             return;
//         }

//         toast({
//             title: "Password Created Successfully",
//             status: "success",
//             duration: 4000,
//             isClosable: true,
//             position: "top",
//         });
//       };
    
//   return (
//      <Box
//           display="flex"
//           justifyContent="center"
//           alignItems="center"
//           minH="100vh"
//           bg="gray.50"
    
//         >
//           <Box
//             bg="white"
//             px={8}
//             py={14}
//             rounded="xl"
//             shadow="md"
//             w="lg"
//             mb={16}
//           >
//             <Heading textAlign="center" mb={6}>
//               Create Password
//             </Heading>
    
//             <form>
//               <VStack spacing={4}>
//                 <FormControl id="email" isRequired isInvalid={!!errors.email}>
//                   <FormLabel>Email address</FormLabel>
//                   <Input type="email" placeholder="Enter your email" value={email} 
//                    onChange={(e) => {
//         setPassword(e.target.value);
//         setErrors((prev) => ({ ...prev, email: "" }));
//       }}/>
//                   <FormErrorMessage>{errors.email}</FormErrorMessage>
//                 </FormControl>
    
//                 <FormControl id="password" isRequired isInvalid={!!errors.password}>
//                   <FormLabel>Password</FormLabel>
//                   <InputGroup>
//                   <Input type={showPassword ? "text" : "password"} placeholder="Enter your password" value={password} 
//                   onChange={(e) => {
//         setPassword(e.target.value);
//         setErrors((prev) => ({ ...prev, password: "" }));
//       }} />

//                    <InputRightElement height="100%">
//                   <IconButton variant="ghost" size="sm" icon={showPassword ?  <Eye size={18} /> : <EyeOff size={18} />  } 
//                   onClick={() => setShowPassword(!showPassword)}
//                   aria-label="Toggle Password visibility" />
//                   </InputRightElement>
//                   </InputGroup>
//                    <FormErrorMessage>{errors.password}</FormErrorMessage>
//                 </FormControl>

                
//                 <FormControl id="confirmPassword" isRequired  isInvalid={!!errors.confirmPassword}>
//                   <FormLabel>Confirm Password</FormLabel>

//                   <InputGroup>
//                   <Input type={showConfirmPassword ? "text" : "password"} placeholder="Confirm your password" value={confirmPassword} 
//                    onChange={(e) => {
//         setConfirmPassword(e.target.value);
//         setErrors((prev) => ({ ...prev, confirmPassword: "" }));
//       }} />
//                   <InputRightElement height="100%">
//                   <IconButton variant="ghost" size="sm" 
//                   icon={showConfirmPassword ? <Eye size={18} /> : <EyeOff size={18} /> } 
//                   onClick={() => setShowConfirmPassword(!showConfirmPassword)}
//                   aria-label="Toggle Confirm Password Visibility" />
//                   </InputRightElement>
//                   </InputGroup>

//                   <FormErrorMessage>{errors.confirmPassword}</FormErrorMessage>
//                 </FormControl>
    
//                 <Button 
//                 type="submit"
//                 onClick={handleSubmit}
//                  onMouseEnter={() => setHover(true)}
//                   onMouseLeave={() => setHover(false)} style={{
//                     width: "100%",
//                     padding: "12px 0",
//                     backgroundColor: "#011638",
//                     backgroundColor: hover ? "#ffffff" : "#011638",
//                     color: hover ? "#000000" : " #ffffff",
//                     fontWeight: "700",
//                     border: hover ? "1px solid #011638" : "none",
//                     borderRadius: "30px",
//                     cursor: "pointer",
//                     fontSize: "1rem",
//                     boxShadow: "0 2px 6px rgba(1, 22, 56, 0.3)",
//                     transition: "all 0.3s ease-in-out",
//                   }} >
//                   Submit
//                 </Button>
//               </VStack>
//             </form>
//           </Box>
//         </Box>
//   );
// }


import React, { useState } from 'react';
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  Heading,
  VStack,
  useToast,
  InputGroup,
  InputRightElement,
  IconButton,
  FormErrorMessage,
  Spinner
} from "@chakra-ui/react";
import { Eye, EyeOff } from "lucide-react";
import { changePassword } from '../redux/api/admin/authApi';
import { useNavigate } from 'react-router-dom';

export default function CreatePassword() {
  const toast = useToast();
  const [hover, setHover] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleChangePassword = async (e) => {
    e.preventDefault();
    
    // Frontend validation
    if (!email) {
      toast({
        title: "Error",
        description: "Please enter your email address",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }
    
    if (password.length < 8) {
      setPasswordError("Password must be at least 8 characters long.");
      return;
    } else if (password !== confirmPassword) {
      setPasswordError("Passwords do not match!");
      return;
    }
    setPasswordError("");
    
    const data = {
      newPassword: password,
      confPassword: confirmPassword,
      email: email,
    };
    setIsLoading(true);
    
    try {
      const response = await changePassword(data);
      console.log("Password Created response:", response);
      
      // Check if response.data exists and has success property
      if (response.data && response.data.success) {
        toast({
          title: "Success",
          description: response.data.message || "Password Created successfully!",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
        navigate("/admin-login");
      } else if (response.data) {
        // Handle backend error responses
        if (response.data.msg === "Invalid Email") {
          toast({
            title: "Error",
            description: "Invalid email address. Please check your email.",
            status: "error",
            duration: 3000,
            isClosable: true,
          });
        } else if (response.data.error) {
          toast({
            title: "Error",
            description: `Error: ${response.data.error}`,
            status: "error",
            duration: 3000,
            isClosable: true,
          });
        } else if (response.data.message) {
          toast({
            title: "Error",
            description: response.data.message,
            status: "error",
            duration: 3000,
            isClosable: true,
          });
        } else {
          toast({
            title: "Error",
            description: "Failed to Create Password. Please try again.",
            status: "error",
            duration: 3000,
            isClosable: true,
          });
        }
      } else {
        // If response structure is unexpected
        toast({
          title: "Error",
          description: "Unexpected response from server. Please try again.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error("Error changing password:", error);
      
      // Handle different types of errors
      if (error.response) {
        // The request was made and the server responded with an error status
        const { status, data } = error.response;
        
        switch (status) {
          case 400:
            if (data.msg === "Invalid Email") {
              toast({
                title: "Error",
                description: "Invalid email address. Please check your email.",
                status: "error",
                duration: 3000,
                isClosable: true,
              });
            } else if (data.msg) {
              toast({
                title: "Error",
                description: data.msg,
                status: "error",
                duration: 3000,
                isClosable: true,
              });
            } else if (data.message) {
              toast({
                title: "Error",
                description: data.message,
                status: "error",
                duration: 3000,
                isClosable: true,
              });
            } else {
              toast({
                title: "Error",
                description: "Bad request. Please check your input.",
                status: "error",
                duration: 3000,
                isClosable: true,
              });
            }
            break;
            
          case 401:
            toast({
              title: "Error",
              description: "Unauthorized. Please login again.",
              status: "error",
              duration: 3000,
              isClosable: true,
            });
            break;
            
          case 403:
            toast({
              title: "Error",
              description: "You don't have permission to change this password.",
              status: "error",
              duration: 3000,
              isClosable: true,
            });
            break;
            
          case 404:
            toast({
              title: "Error",
              description: "User not found. Please check your email.",
              status: "error",
              duration: 3000,
              isClosable: true,
            });
            break;
            
          case 409:
            toast({
              title: "Error",
              description: "Password Created conflict. Please try again.",
              status: "error",
              duration: 3000,
              isClosable: true,
            });
            break;
            
          case 500:
            if (data.error) {
              toast({
                title: "Error",
                description: `Server error: ${data.error}`,
                status: "error",
                duration: 3000,
                isClosable: true,
              });
            } else if (data.message) {
              toast({
                title: "Error",
                description: data.message,
                status: "error",
                duration: 3000,
                isClosable: true,
              });
            } else {
              toast({
                title: "Error",
                description: "Server error. Please try again later.",
                status: "error",
                duration: 3000,
                isClosable: true,
              });
            }
            break;
            
          default:
            if (data.msg) {
              toast({
                title: "Error",
                description: data.msg,
                status: "error",
                duration: 3000,
                isClosable: true,
              });
            } else if (data.message) {
              toast({
                title: "Error",
                description: data.message,
                status: "error",
                duration: 3000,
                isClosable: true,
              });
            } else {
              toast({
                title: "Error",
                description: `Error ${status}: Please try again.`,
                status: "error",
                duration: 3000,
                isClosable: true,
              });
            }
        }
        
      } else if (error.request) {
        // The request was made but no response was received
        console.error("No response received:", error.request);
        toast({
          title: "Error",
          description: "No response from server. Please check your connection.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      } else {
        // Something happened in setting up the request
        console.error("Error setting up request:", error.message);
        toast({
          title: "Error",
          description: "An error occurred. Please try again.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      {isLoading && (
        <Box
          position="fixed"
          top="0"
          left="0"
          right="0"
          bottom="0"
          backgroundColor="rgba(0, 0, 0, 0.5)"
          display="flex"
          alignItems="center"
          justifyContent="center"
          zIndex="9999"
        >
          <Spinner size="xl" color="white" />
        </Box>
      )}
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minH="100vh"
        bg="gray.50"
      >
        <Box
          bg="white"
          px={8}
          py={14}
          rounded="xl"
          shadow="md"
          w="lg"
          mb={16}
        >
          <Heading textAlign="center" mb={6}>
            Create Password
          </Heading>

          <form>
            <VStack spacing={4}>
              <FormControl id="email" isRequired isInvalid={!!errors.email}>
                <FormLabel>Email address</FormLabel>
                <Input 
                  type="email" 
                  placeholder="Enter your email" 
                  value={email} 
                  onChange={(e) => {
                    setEmail(e.target.value);
                    setErrors((prev) => ({ ...prev, email: "" }));
                  }}
                />
                <FormErrorMessage>{errors.email}</FormErrorMessage>
              </FormControl>

              <FormControl id="password" isRequired isInvalid={!!errors.password || !!passwordError}>
                <FormLabel>Password</FormLabel>
                <InputGroup>
                  <Input 
                    type={showPassword ? "text" : "password"} 
                    placeholder="Enter your password" 
                    value={password} 
                    onChange={(e) => {
                      setPassword(e.target.value);
                      setErrors((prev) => ({ ...prev, password: "" }));
                      setPasswordError("");
                    }} 
                  />
                  <InputRightElement height="100%">
                    <IconButton 
                      variant="ghost" 
                      size="sm" 
                      icon={showPassword ? <Eye size={18} /> : <EyeOff size={18} />} 
                      onClick={() => setShowPassword(!showPassword)}
                      aria-label="Toggle Password visibility" 
                    />
                  </InputRightElement>
                </InputGroup>
                <FormErrorMessage>
                  {errors.password || passwordError}
                </FormErrorMessage>
              </FormControl>

              <FormControl id="confirmPassword" isRequired isInvalid={!!errors.confirmPassword}>
                <FormLabel>Confirm Password</FormLabel>
                <InputGroup>
                  <Input 
                    type={showConfirmPassword ? "text" : "password"} 
                    placeholder="Confirm your password" 
                    value={confirmPassword} 
                    onChange={(e) => {
                      setConfirmPassword(e.target.value);
                      setErrors((prev) => ({ ...prev, confirmPassword: "" }));
                      setPasswordError("");
                    }} 
                  />
                  <InputRightElement height="100%">
                    <IconButton 
                      variant="ghost" 
                      size="sm" 
                      icon={showConfirmPassword ? <Eye size={18} /> : <EyeOff size={18} />} 
                      onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                      aria-label="Toggle Confirm Password Visibility" 
                    />
                  </InputRightElement>
                </InputGroup>
                <FormErrorMessage>{errors.confirmPassword}</FormErrorMessage>
              </FormControl>

              <Button 
                type="submit"
                onClick={handleChangePassword}
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
                disabled={isLoading}
                style={{
                  width: "100%",
                  padding: "12px 0",
                  backgroundColor: hover ? "#ffffff" : "#011638",
                  color: hover ? "#000000" : "#ffffff",
                  fontWeight: "700",
                  border: hover ? "1px solid #011638" : "none",
                  borderRadius: "30px",
                  cursor: isLoading ? "not-allowed" : "pointer",
                  fontSize: "1rem",
                  boxShadow: "0 2px 6px rgba(1, 22, 56, 0.3)",
                  transition: "all 0.3s ease-in-out",
                  opacity: isLoading ? 0.7 : 1,
                }}
              >
                {isLoading ? "Processing..." : "Submit"}
              </Button>
            </VStack>
          </form>
        </Box>
      </Box>
    </>
  );
}